/**
 * Default tax rates used when no user-provided rates are available
 */
export const US_DEFAULT_SHORT_TERM_CAPITAL_GAINS_RATE = 0.38;
export const US_DEFAULT_LONG_TERM_CAPITAL_GAINS_RATE = 0.24;
